import { useAuth } from "@clerk/clerk-react";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import StyledCard from "components/Styled/Card";
import StyledVaPage from "components/Styled/VAPage";
import BrandPreferencesSettings from "features/Influencer/VA/VASettings/GeneralSettings/BrandPreferences";
import { fetcherAuth } from "utils/api";
import { useTracking } from "utils/useTracking";

const SelfServeVaBrandPreferences = () => {
  const { getToken } = useAuth();
  const { setErrorAlert } = useContext(AlertContext);

  const { currentOrg, organizationVaProfile } = useContext(
    OrganizationUserContext,
  );
  const [loading, setLoading] = useState(false);
  const { trackVaStep } = useTracking();
  const navigate = useNavigate();

  const handleSubmitPreferences = async () => {
    try {
      setLoading(true);
      await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/va-settings`,
        "PUT",
        {},
        {
          openToGifted: organizationVaProfile?.openToGifted,
          openToAffiliates: organizationVaProfile?.openToAffiliates,
          openToForms: organizationVaProfile?.openToForms,
          openToSocial: organizationVaProfile?.openToSocial,
        },
      );
      navigate(`/${routes.emailWarmupSelfServeOnboarding}`);
      trackVaStep(routes.emailWarmupSelfServeOnboarding);
    } catch (error) {
      setErrorAlert(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledVaPage
      stepNumber={4}
      title="Collab Preferences"
      description={
        <>
          Let's customize how your virtual assistant reaches out to brands on
          your behalf.
          <br />
          You can always change this later in your dashboard
        </>
      }
      body={
        <StyledCard styles={{ px: 2, py: 4, mb: 4 }}>
          <BrandPreferencesSettings />
        </StyledCard>
      }
      onBack={() => {
        trackVaStep(routes.templatesSelfServeOnboarding);
        navigate(`/${routes.templatesSelfServeOnboarding}`);
      }}
      buttonBack={"Go Back to Templates"}
      buttonNext={"Continue to Email Warmup"}
      onNext={handleSubmitPreferences}
      loading={loading}
    />
  );
};

export default SelfServeVaBrandPreferences;
